import { render } from "./AzuriomInstaller.vue?vue&type=template&id=3c16f055&ts=true"
import script from "./AzuriomInstaller.vue?vue&type=script&lang=ts"
export * from "./AzuriomInstaller.vue?vue&type=script&lang=ts"

import "./AzuriomInstaller.vue?vue&type=style&index=0&id=3c16f055&lang=scss"

import exportComponent from "/Users/paul/Documents/JetBrains/PhpstormProjects/AzuriomInstaller/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__